import store from '@/config/vuex'
import actionEventsMapping, { ACTIONS, CONTEXTS } from './action-events-mapping'
import eventServiceMapping from './event-service-mapping'

function dispatchExternalEvents(payload) {
  const events = actionEventsMapping[payload.action]
  Object.keys(events).forEach(event => {
    const eventPayload = events[event](payload, store)
    eventServiceMapping[event](event, eventPayload)
  })
}

export { ACTIONS, CONTEXTS  }

export const notifyExternalServices = payload => {
  dispatchExternalEvents(payload)
  // other things than events can also be dispatched here...
}

On.notifyExternalServices = notifyExternalServices
On.EXTERNAL_SERVICES_ACTIONS = ACTIONS
